module.exports = __webpack_public_path__ + "static/media/1.db269c40.jpg";